import { createClient } from '@supabase/supabase-js'

// Project credentials
const SUPABASE_URL = 'https://ymwrzyarkxxnsqllnnfu.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inltd3J6eWFya3h4bnNxbGxubmZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzNTY4MzMsImV4cCI6MjA3MDkzMjgzM30.rhpDzZVnhh4Mmotz_G5wbpxkAZtjGsyH5oRFB56Et6E'

if (SUPABASE_URL === 'https://your-project-id.supabase.co' || SUPABASE_ANON_KEY === 'your-anon-key') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'nupitch-auth-token',
    flowType: 'pkce'
  }
})

export default supabase